import {
  AvField,
  AvForm,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import { Component } from "react";
import { Redirect } from "react-router-dom";
import {
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import { ConfirmAlert } from "../../../helpers/ui/alert";
import { Link } from "react-router-dom";
import apiResponse from "../../../services/apiResponse";
import UpdateBloc from "./Blocs/UpdateBloc";
import Wysiwyg from "../Detail/Components/Wysiwyg";
import { FileInput, generateFormData } from "../../../helpers/ui/FileInput";
import CustomSelect from "../../../helpers/ui/CustomSelect"

class IndexView extends Component {
  updateBloc = new UpdateBloc();
  userdata = JSON.parse(localStorage.getItem("userdata"));

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        announcement_created_by: JSON.parse(localStorage.getItem("userdata"))
          .employee_uuid,
      },
      optPopupAnnouncement: [
        {
          label: "Ya",
          value: "1"
        },
        {
          label: "Tidak",
          value: "0"
        }
      ],
      announcement: []
    };
  }

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, {
      field: "attachment_detail",
      name: "announcementAttachments/attachment",
    });
    // console.log(this.state.dataForm)
    await this.updateBloc.fetchUpdate(formData);
  };

  handlerOnSubmit = (e, values) => {
    const queryParams = new URLSearchParams(window.location.search);

    e.preventDefault();

    this.setState({
      dataForm: {
        announcement_uuid: queryParams.get("uuid"),
        announcement_content_html: this.state.dataForm["announcement_content_html"],
        ...values
      },
    });
    this.setState({
      confirm: true,
    });
  };

  handleContentChange = (value, valueHtml) => {
    this.setState({
      dataForm: {
        ...this.state.dataForm,
        announcement_content: value,
        announcement_content_html: valueHtml,
      },
    });
  };

  handleTitleChange = (e) => {
    this.setState({
      dataForm: {
        ...this.state.dataForm,
        [e.currentTarget.name]: e.currentTarget.value,
      },
    });
  };

  handleIsPopupChange = (data) => {
    this.setState({
      dataForm: {
        ...this.state.dataForm,
        "is_popup_announcement": data.value,
      },
    });
  };

  preventEnter = (e) => {
    if (e.which === 13 && !e.target.getAttribute("role")) {
      e.preventDefault();
    }
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            announcement: response.result,
            dataForm: {
              announcement_title: response.result.announcement_title,
              announcement_content: response.result.announcement_content,
              announcement_content_html: response.result.announcement_content_html,
              is_popup_announcement: response.result.is_popup_announcement
            }
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    })

    const queryParams = new URLSearchParams(window.location.search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid"), employee_uuid: this.userdata.employee_uuid });

  }

  componentWillUnmount() {
    this.updateBloc.detailChannel.unsubscribe();
    this.updateBloc.updateChannel.unsubscribe();
  }

  renderCardForm = () => {
    return (
      <Card>
        <CardBody>
          <CardTitle>Ubah Pengumuman</CardTitle>
          <CardSubtitle className="mb-3">
            Ubah pengumuman dengan mengisi form di bawah ini
          </CardSubtitle>
          <hr />
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => {
              this.handlerOnSubmit(e, values);
            }}
            onKeyPress={this.preventEnter}
            ref={this.formRef}
          >
            <Row className="mb-3">
              <label
                htmlFor="announcement_title"
                className="col-md-3 col-form-label"
              >
                Judul <span className="text-danger">*</span>
              </label>
              <Col md="9">
                <AvField
                  name="announcement_title"
                  placeholder="Masukkan judul pengumuman..."
                  type="text"
                  errorMessage="Judul tidak boleh kosong."
                  className="form-control"
                  validate={{ required: { value: true } }}
                  id="announcement_title"
                  value={this.state.announcement.announcement_title}
                  onChange={this.handleTitleChange}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <label
                htmlFor="announcement_content"
                className="col-md-3 col-form-label"
              >
                Isi pengumuman <span className="text-danger">*</span>
              </label>
              <Col md="9">
                <Container
                  style={{
                    overflow: "hidden",
                    minHeight: "18rem",
                    padding: "0",
                  }}
                >
                  {this.state.announcement.announcement_content_html && (
                    <Wysiwyg defaultValue={this.state.announcement.announcement_content_html} changeValue={this.handleContentChange} />
                  )}
                
                  <AvField
                    name="announcement_content"
                    type="hidden"
                    value={this.state.dataForm.announcement_content}
                  />
                </Container>
              </Col>
            </Row>

            <Row className="mb-3">
              <label
                htmlFor="is_popup_announcement"
                className="col-md-3 col-form-label"
              >
                Set sebagai popup <span className="text-danger">*</span>
              </label>
              <Col md="9">
                <CustomSelect
                  name="is_popup_announcement"
                  id="is_popup_announcement"
                  options={this.state.optPopupAnnouncement}
                  validate={{ required: { value: true } }}
                  onChange={this.handleIsPopupChange}
                  defaultValue={'' + this.state.announcement.is_popup_announcement}
                  placeholder="Set sebagai popup" />
              </Col>
            </Row>

            <Row className="mb-3">
              <label className="col-md-3 col-form-label">Lampiran</label>
              <Col md={9}>
                <FileInput
                  name="attachment_detail"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="3"></Col>
              <Col md="9">
                <div className="form-check form-switch mb-3">
                  <AvCheckboxGroup
                    name="checkboxAgreement"
                    required
                    errorMessage="Agreement harus di centang"
                  >
                    <AvCheckbox
                      label="Saya yakin dan bertanggung jawab atas data ini"
                      value="1"
                    />
                  </AvCheckboxGroup>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="3"></Col>
              <Col md="9">
                <Link to="pengumuman.html">
                  <Button color="danger">
                    <i className="uil-arrow-left"></i> Kembali
                  </Button>
                </Link>{" "}
                <Button color="success" type="submit">
                  <i className="uil-save"></i> Simpan
                </Button>
              </Col>
            </Row>
          </AvForm>
        </CardBody>
      </Card>
    );
  };

  render() {
    return (
      <>
        <Container fluid>
          <Row>
            <Col className="col-12">{this.renderCardForm()}</Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan mengupdate data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diupdate"
          failedTitle="Gagal!"
          failedInfo="Data gagal diupdate"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? <Redirect to="/admin/pengumuman.html" /> : null}
      </>
    );
  }
}

export default IndexView;
